<div class="flex min-w-0 flex-1 w-full flex-col sm:flex-row items-stretch min-h-full">
  <div
    class="w-full px-4 py-8 sm:w-auto sm:rounded-2xl sm:p-12 sm:shadow md:flex md:w-1/2 md:items-center md:justify-end md:rounded-none md:p-16 md:shadow-none"
  >
    <div class="mx-auto w-full max-w-80 sm:mx-0 sm:w-80">
      <!-- Logo & App Name -->
      <div class="mb-6 flex items-center">
        <a
          [routerLink]="resolvedLogoLink()"
          class="group flex items-center gap-3 no-underline cursor-pointer select-none"
        >
          @if (resolvedLogoUrl()) {
            <img
              [src]="resolvedLogoUrl()"
              [alt]="resolvedLogoAlt()"
              class="h-10 w-10 shrink-0 transition-transform group-hover:scale-105"
            />
          }
          @if (resolvedAppName()) {
            <span class="font-mono text-5xl font-bold tracking-tight uppercase text-neutral-12">
              {{ resolvedAppName() }}
            </span>
          }
        </a>
      </div>
      <ng-content select="[main]"></ng-content>
    </div>
  </div>
  <div
    class="bg-neutral-2 border-l border-neutral-3 relative hidden w-1/2 flex-1 min-w-0 items-center justify-center overflow-hidden p-8 md:flex md:p-12 lg:px-24"
  >
    <!-- Background -->
    <!-- Rings -->
    <svg
      class="pointer-events-none absolute inset-0"
      viewBox="0 0 960 540"
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMax slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g class="text-neutral-6 opacity-30" fill="none" stroke="currentColor" stroke-width="100">
        <circle r="234" cx="196" cy="23"></circle>
        <circle r="234" cx="790" cy="491"></circle>
      </g>
    </svg>

    <!-- Content -->
    <div class="relative z-10 w-full min-w-0 max-w-2xl">
      <ng-content select="[right]"></ng-content>
    </div>
  </div>
</div>
